enum sort {
  ASC = 'ASC',
  DESC = 'DESC',
}

export default sort;
